/**
 * Centralized Environment Configuration
 * 
 * This file manages all environment-specific settings including API URLs,
 * feature flags, and other configuration values.
 */

// Environment detection
const getEnvironment = () => {
  const hostname = window.location.hostname;
  const port = window.location.port;
  
  // Development environment detection
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'development';
  }
  
  // Production environment detection
  if (hostname.includes('lumimatrimony.com')) {
    if (hostname.includes('dev.')) {
      return 'development';
    } else if (hostname.includes('uat.') || hostname.includes('staging.')) {
      return 'staging';
    } else {
      return 'production';
    }
  }
  
  // Default to development
  return 'development';
};

// Environment-specific configurations
const environments = {
  development: {
    API_BASE_URL: 'https://bureau.dev.lumimatrimony.com/api',
    MASTER_DATA_API_BASE_URL: 'https://bureau.dev.lumimatrimony.com/api/masterdata',
    DEBUG_MODE: true,
    LOG_LEVEL: 'debug',
    ENABLE_REDUX_DEVTOOLS: true
  },
  staging: {
    API_BASE_URL: 'https://bureau.dev.lumimatrimony.com/api',
    MASTER_DATA_API_BASE_URL: 'https://bureau.dev.lumimatrimony.com/api/masterdata',
    DEBUG_MODE: true,
    LOG_LEVEL: 'warn',
    ENABLE_REDUX_DEVTOOLS: true
  },
  production: {
    API_BASE_URL: 'https://bureau.dev.lumimatrimony.com/api',
    MASTER_DATA_API_BASE_URL: 'https://bureau.dev.lumimatrimony.com/api/masterdata',
    DEBUG_MODE: false,
    LOG_LEVEL: 'error',
    ENABLE_REDUX_DEVTOOLS: false
  }
};

// Get current environment
const currentEnvironment = getEnvironment();

// Export configuration for current environment
export const ENV_CONFIG = {
  ENVIRONMENT: currentEnvironment,
  ...environments[currentEnvironment]
};

// Utility functions
export const isProduction = () => currentEnvironment === 'production';
export const isDevelopment = () => currentEnvironment === 'development';
export const isStaging = () => currentEnvironment === 'staging';

// Debug logging
if (ENV_CONFIG.DEBUG_MODE) {
  console.log('🔧 Environment Configuration:', {
    environment: currentEnvironment,
    hostname: window.location.hostname,
    apiBaseUrl: ENV_CONFIG.API_BASE_URL,
    masterDataApiBaseUrl: ENV_CONFIG.MASTER_DATA_API_BASE_URL
  });
}

export default ENV_CONFIG;
